import { gql } from '@apollo/client';
import { StaffingSettings } from './staffing-settings.fragment';
export const UpdateStaffingSettings = gql `
    mutation UpdateStaffingSettings($siteSetId: SiteSetId!, $updateInput: StaffingSettingsUpdateInputType!) {
        staffhours {
            settings {
                updateAll(siteSetId: $siteSetId, updateInput: $updateInput) {
                    ...StaffingSettings
                }
            }
        }
    }
    ${StaffingSettings}
`;
